import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

const PREVIEW_CLIENT = {
  name: 'John',
  reviewLink: 'https://g.co/r/review-link',
  appointmentDate: 'Jan 15, 2026',
  appointmentTime: '2:00 PM',
};

const MessagePreview = ({ messageText, attachments = [] }) => {
  const auth = useSelector(state => state.auth);

  const associateName = [auth.firstName, auth.lastName].filter(Boolean).join(' ') || 'Associate';
  const storeName = auth.stores?.find(s => s.id === auth.storeId)?.name || 'Store';
  const merchantName = auth.brandName || 'Merchant';

  // Build the substituted preview text
  const previewText = useMemo(() => {
    if (!messageText) return '';
    let text = messageText;

    const substitutions = {
      ':name:': PREVIEW_CLIENT.name,
      ':associate:': associateName,
      ':assigned_associate_name:': associateName,
      ':store:': storeName,
      ':merchant:': merchantName,
      ':review:': PREVIEW_CLIENT.reviewLink,
      ':appointment_date:': PREVIEW_CLIENT.appointmentDate,
      ':appointment_time:': PREVIEW_CLIENT.appointmentTime,
    };

    Object.entries(substitutions).forEach(([token, value]) => {
      text = text.replace(new RegExp(token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), value);
    });

    return text;
  }, [messageText, associateName, storeName, merchantName]);

  return (
    <div className="mass-message-form__preview">
      <div className="mass-message-form__preview-body">
        <div className="mass-message-form__preview-bubble">
          <div className="mass-message-form__preview-bubble-text">
            {previewText || 'Your message will appear here...'}
          </div>
          {attachments.length > 0 && (
            <div className="mass-message-form__preview-attachments">
              {attachments.map((att, i) => {
                const url = typeof att === 'string' ? att : att.url;
                return url && !att.uploading ? (
                  <img key={att.id || i} src={url} alt="" className="mass-message-form__preview-att-img" />
                ) : null;
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MessagePreview;
